import {
  AppContext,
  DATE_FORMAT_FOR_DATE_PICKER,
  TIME_FORMAT_HH_MM_A
} from '@nile/components';
import dayjs from 'dayjs';
import React, { useContext } from 'react';
import DatePicker from 'react-datepicker';
import { withErrorBoundary } from '../HOC';

const DateTimePicker = (props) => {
  const context = useContext(AppContext);
  let { dateFormat, timeFormat } = context?.company || {};
  dateFormat = dateFormat || 'DD/MM/YYYY';
  const properties = {
    timeIntervals: 15,
    popperPlacement: 'right',
    minDate: dayjs(new Date()).toDate(),
    onKeyDown: (e) => e.preventDefault(),
    placeholderText: 'Choose date and time',
    dateFormat: props?.showTimeSelect
      ? `${DATE_FORMAT_FOR_DATE_PICKER[dateFormat] ||
          'dd/MM/yyyy'} ${timeFormat || TIME_FORMAT_HH_MM_A}`
      : `${DATE_FORMAT_FOR_DATE_PICKER[dateFormat] || 'dd/MM/yyyy'}`,
    selected: dayjs(props?.selected || new Date()).toDate(),
    ...props
  };

  return <DatePicker {...properties} />;
};

export default withErrorBoundary(DateTimePicker);
